import { memo, useMemo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { SegmentedControl } from '@aimsos/ui';

import { NOTE_SCOPES } from '../../../../services/notes.js';

/**
 * Public or private — the ONE metadatum a note has (CT-5528).
 *
 * A `SegmentedControl`, not a `Switch`: it is a two-value CHOICE, not an on/off
 * setting. Who can read a private note is the backend's decision; this only says
 * which of the two the author wants.
 */
const NoteScopeControl = memo(function NoteScopeControl({ value, onChange, disabled = false }) {
  const { t } = useTranslation('unified-profiles');

  const options = useMemo(
    () => [
      { value: NOTE_SCOPES.PUBLIC, label: t('notes.scope.public') },
      { value: NOTE_SCOPES.PRIVATE, label: t('notes.scope.private') },
    ],
    [t],
  );

  return (
    <fieldset disabled={disabled} className="m-0 flex flex-col gap-1.5 border-0 p-0">
      <legend className="mb-1.5 p-0 text-sm font-medium text-content-secondary">{t('notes.scope.label')}</legend>
      <SegmentedControl
        value={value}
        onChange={onChange}
        options={options}
        activeColor="primary"
        ariaLabel={t('notes.scope.label')}
      />
      <p className="text-xs text-content-muted">
        {t(value === NOTE_SCOPES.PRIVATE ? 'notes.scope.privateHint' : 'notes.scope.publicHint')}
      </p>
    </fieldset>
  );
});

export default NoteScopeControl;
